<template>
  <ModalSelectNodeGalGameEditor
    :title="$t('Texts.cloneSelectedNodeBelow')"
    v-model:show="store.showCloneNodeModal"
    @confirm="onConfirm"
  />
</template>

<script lang="ts" setup>
import { useGalGameEditor } from "@/stores/galGameEditor";

const store = useGalGameEditor();

const onConfirm = (targetNodeId: number) => {
  store.cloneNode(targetNodeId);
  store.showCloneNodeModal = false;
};
</script>
